import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Auth } from 'aws-amplify';
import { selectAuthState } from '../store';
import { setEmail, setUser, setAttributes } from '../store/auth.actions';
import { SsoService } from '../services/sso.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedSectionGuard
  implements CanActivate, CanActivateChild
{
  constructor(
    private router: Router,
    private store: Store,
    private ssoService: SsoService
  ) {}

  async fetchCognitoUser() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        const attributes = user.attributes;
        const identities = user.attributes.identities
          ? JSON.parse(user.attributes.identities)
          : [];
        const { email } = attributes;
        this.store.dispatch(setEmail({ payload: email }));
        if (identities.length > 0 && attributes) {
          console.log(identities[0]);
          if (identities[0]?.providerType === 'OIDC') {
            attributes.loginType = 'sso';
            attributes.externalUserId = identities[0]?.userId;
          } else if (identities[0]?.providerType === 'SAML') {
            attributes.loginType = 'sso';
            attributes.externalUserId = attributes['custom:etsGUID'] as string;
            attributes['custom:userType'] = 'student';
            if (email.includes('edu')) {
              attributes['custom:userType'] = 'teacher';
            }
            this.store.dispatch(setUser({ payload: user }));
            this.store.dispatch(setAttributes({ payload: attributes }));
          }
        }
      }
    } catch (err) {
      this.store.dispatch(setUser({ payload: undefined }));
      this.store.dispatch(setAttributes({ payload: undefined }));
    }
    this.store.select(selectAuthState).subscribe((auth) => console.log(auth));
  }

  async canActivate() {
    try {
      await this.fetchCognitoUser();
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        return true;
      } else {
        this.router.navigate(['/auth/sign-in']);
        return false;
      }
    } catch (err) {
      console.log('Error Occured : User not authenticated:', err);
      this.router.navigate(['/auth/sign-in']);
      return false;
    }
  }

  async canActivateChild() {
    try {
      await this.fetchCognitoUser();
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        return true;
      } else {
        this.router.navigate(['/auth/sign-in']);
        return false;
      }
    } catch (err) {
      console.log('Error Occured : User not authenticated:', err);
      this.router.navigate(['/auth/sign-in']);
      return false;
    }
  }
}
